/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Pending_NoteInputs */

const th_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีกรรมการจะได้รับการตรวจสอบโดยผู้จัดก่อนที่คุณจะบันทึกคะแนนได้`)
};

const en_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A referee account is checked by an organiser before you can score games.`)
};

const ja_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`審判アカウントは、得点を記録する前に主催者による確認が必要です。`)
};

const zh_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裁判账户需由主办方审核，之后你才能录入比分。`)
};

const es_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un organizador revisa las cuentas de árbitro antes de que puedas anotar partidos.`)
};

const pt_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta de árbitro é conferida por um organizador antes de você poder lançar placares.`)
};

const id_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun wasit ditinjau penyelenggara sebelum Anda bisa memasukkan skor.`)
};

const fr_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un compte d’arbitre est vérifié par un organisateur avant que vous puissiez saisir des scores.`)
};

const tl_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusuri ng organizer ang referee account bago ka makapaglagay ng iskor.`)
};

const vi_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản trọng tài được ban tổ chức xem xét trước khi bạn nhập được tỉ số.`)
};

const ko_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수를 입력하려면 먼저 주최자가 심판 계정을 검토합니다.`)
};

const de_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schiedsrichterkonto wird von einem Veranstalter geprüft, bevor du Ergebnisse eintragen kannst.`)
};

const ru_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Судейский аккаунт проверяет организатор, прежде чем вы сможете вводить счёт.`)
};

const tr_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor girebilmeniz için hakem hesabınız bir düzenleyici tarafından incelenir.`)
};

const it_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un account da arbitro viene verificato da un organizzatore prima che tu possa inserire i punteggi.`)
};

const pl_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto sędziego sprawdza organizator, zanim będziesz mógł wpisywać wyniki.`)
};

const uk_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обліковий запис судді перевіряє організатор, перш ніж ви зможете вводити рахунок.`)
};

const hi_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कोर दर्ज करने से पहले रेफ़री खाते की जाँच एक आयोजक करता है।`)
};

const ar_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يراجع المنظّم حساب الحكم قبل أن تتمكن من إدخال النتائج.`)
};

const ms_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun pengadil disemak oleh penganjur sebelum anda boleh memasukkan mata.`)
};

const bn_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর দেওয়ার আগে রেফারি অ্যাকাউন্ট একজন আয়োজক যাচাই করেন।`)
};

const zh_tw2_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裁判帳戶須經主辦單位審核，之後你才能輸入比分。`)
};

const zh_hk2_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裁判帳戶須經主辦單位審核，之後你才能輸入比分。`)
};

const ur_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکور درج کرنے سے پہلے ریفری اکاؤنٹ کا جائزہ ایک منتظم لیتا ہے۔`)
};

const fa_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیش از آنکه بتوانید نتیجه وارد کنید، حساب داوری را برگزارکننده بررسی می‌کند.`)
};

const sw_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti ya urefa hukaguliwa na mwandalizi kabla hujaweza kuweka matokeo.`)
};

const nl_role_pending_note = /** @type {(inputs: Role_Pending_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een scheidsrechtersaccount wordt door een organisator bekeken voordat je standen kunt invoeren.`)
};

/**
* | output |
* | --- |
* | "A referee account is checked by an organiser before you can score games." |
*
* @param {Role_Pending_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const role_pending_note = /** @type {((inputs?: Role_Pending_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Pending_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_role_pending_note(inputs)
	if (locale === "ja") return ja_role_pending_note(inputs)
	if (locale === "zh") return zh_role_pending_note(inputs)
	if (locale === "es") return es_role_pending_note(inputs)
	if (locale === "pt") return pt_role_pending_note(inputs)
	if (locale === "id") return id_role_pending_note(inputs)
	if (locale === "fr") return fr_role_pending_note(inputs)
	if (locale === "tl") return tl_role_pending_note(inputs)
	if (locale === "vi") return vi_role_pending_note(inputs)
	if (locale === "ko") return ko_role_pending_note(inputs)
	if (locale === "de") return de_role_pending_note(inputs)
	if (locale === "ru") return ru_role_pending_note(inputs)
	if (locale === "tr") return tr_role_pending_note(inputs)
	if (locale === "it") return it_role_pending_note(inputs)
	if (locale === "pl") return pl_role_pending_note(inputs)
	if (locale === "uk") return uk_role_pending_note(inputs)
	if (locale === "hi") return hi_role_pending_note(inputs)
	if (locale === "ar") return ar_role_pending_note(inputs)
	if (locale === "ms") return ms_role_pending_note(inputs)
	if (locale === "bn") return bn_role_pending_note(inputs)
	if (locale === "zh-TW") return zh_tw2_role_pending_note(inputs)
	if (locale === "zh-HK") return zh_hk2_role_pending_note(inputs)
	if (locale === "ur") return ur_role_pending_note(inputs)
	if (locale === "fa") return fa_role_pending_note(inputs)
	if (locale === "sw") return sw_role_pending_note(inputs)
	if (locale === "nl") return nl_role_pending_note(inputs)
	return en_role_pending_note(inputs)
});